import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { INSTRUMENTS } from "@/data/curriculum";
import { api } from "@/lib/api";

// Sends a student straight to the first unfinished lesson in a course they own (last-opened course first).
export default function NextLesson() {
  const nav = useNavigate();
  useEffect(() => {
    Promise.all([api.get("/progress"), api.get("/purchases")]).then(([{ data: p }, { data: b }]) => {
      const done = new Set((p.completed_lessons || []).map(Number));
      const owned = new Set(b.course_keys || []);
      const last = Number(p.last_lesson_id);
      const has = (c) => (c.lessons.some((l) => l.id === last) ? 1 : 0);
      const courses = INSTRUMENTS.flatMap((i) => i.courses.map((c) => ({ key: `${i.id}:${c.id}`, c })))
        .filter((x) => owned.has(x.key)).sort((a, b2) => has(b2.c) - has(a.c));
      for (const { c } of courses) {
        const next = c.lessons.find((l) => !done.has(l.id));
        if (next) { nav(`/lessons/${next.id}`, { replace: true }); return; }
      }
      nav("/dashboard", { replace: true });
    }).catch(() => nav("/dashboard", { replace: true }));
  }, [nav]);
  return <div className="flex min-h-screen items-center justify-center" data-testid="next-lesson-loading"><Loader2 className="animate-spin text-primary" /></div>;
}
